import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://gdnz.cc/api', // 替换为你的 API 地址
    timeout: 10000,
});

export default instance;
